import { type Theme } from '@mui/material';
import { type CSSObject } from '@mui/material/styles';

export const inputStyles = ({ palette, typography }: Theme, withButton?: boolean): CSSObject => ({
  '& .MuiFilledInput-root': {
    fontFamily: typography.fontFamily,
    caretColor: palette.dark,
    backgroundColor: 'white',
    borderRadius: '16px',
    border: `1px solid ${palette.pale_accent}`,
    height: '56px',
    padding: '8px 12px 6px 16px',
    alignItems: 'flex-end',
    color: palette.dark,

    '&:hover': {
      backgroundColor: 'white',
      borderColor: palette.accent,
    },

    '&.Mui-focused': {
      backgroundColor: 'white',
      borderColor: palette.accent,
      '&:not(.Mui-error)': {
        boxShadow: `0 4px 24px ${palette.accent_25}`,
      },
    },

    '&::before, &::after': {
      display: 'none',
    },
  },

  '& .MuiInputLabel-root': {
    left: '5px',
    top: 0,
    color: palette.light_dark,
    ...typography.body_14_24,

    '&.Mui-focused, &.MuiFormLabel-filled': {
      color: palette.light_dark,
      ...typography.subtitle_alt,
    },
  },

  '& .MuiInputAdornment-positionEnd': {
    pr: 3,
    alignSelf: 'center',
    ...(withButton && {
      pr: 0,
      alignSelf: 'end',
    }),
  },

  '& .MuiIconButton-root': {
    p: 0,
    color: palette.dark,
  },

  '& .MuiFilledInput-input': {
    ...typography.body_14_20,
    padding: 0,

    '&:-webkit-autofill, &:-webkit-autofill::first-line': {
      ...typography.body_14_20,
      WebkitTextFillColor: palette.dark,
      WebkitBoxShadow: '0 0 0 1000px #fff inset',
      caretColor: palette.dark,
      transition: 'background-color 9999s ease-out 0s',
    },
  },

  '& input:-webkit-autofill, & input:-webkit-autofill::first-line': {
    WebkitBoxShadow: '0 0 0 1000px #fff inset !important',
    boxShadow: '0 0 0 1000px #fff inset !important',
    WebkitTextFillColor: `${palette.dark} !important`,
    caretColor: `${palette.dark} !important`,
    borderRadius: 0,
  },

  '& .MuiFilledInput-root.Mui-disabled input:-webkit-autofill, & .MuiFilledInput-root.Mui-disabled input:-webkit-autofill::first-line':
    {
      WebkitBoxShadow: `0 0 0 1000px ${palette.backgroundColor} inset !important`,
      boxShadow: `0 0 0 1000px ${palette.backgroundColor} inset !important`,
      WebkitTextFillColor: `${palette.dark} !important`,
      caretColor: `${palette.dark} !important`,
    },

  '& .MuiFilledInput-root.Mui-error': {
    borderColor: palette.error.main,

    '& .MuiFilledInput-input::placeholder': {
      color: palette.error.main,
      opacity: 1,
    },
  },

  '& .MuiFilledInput-root.Mui-disabled': {
    borderColor: palette.bgDark,
    backgroundColor: palette.backgroundColor,
  },

  '& .MuiFormHelperText-root': {
    '::first-letter': {
      textTransform: 'uppercase',
    },
    marginLeft: '17px',
  },
});
